/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const locationSummarySchema = z.object({
  archivedAt: z.iso.datetime().nullish(),
  countryCode: z.string(),
  id: z.int(),
  subdivisionCode: z.string().nullish(),
});
